import _ from "lodash";
export const TrimTrailingSlashes = url => {
  if (_.endsWith(url, "/")) {
    return TrimTrailingSlashes(_.replace(url, /\/$/, ""));
  }
  return url;
};
